<template>
    <div class="filter-box">
       <FilterCities v-on:changeFilter="changeValue"></FilterCities>
      <status  v-on:changeFilter="changeValue"></status>
      <search v-on:changeFilter="changeValue"></search>
      <date-from v-on:changeFilter="changeValue"></date-from>
      <date-to  v-on:changeFilter="changeValue"></date-to>

    </div>
</template>

<script>
import FilterCities from './filters/cities'
import status from './filters/status'
import search from './filters/search'
import DateFrom from './filters/dateFrom'
import DateTo from './filters/dateTo'
export default {
  name: 'flt',
  components: {DateFrom, DateTo, search, FilterCities, status},
  methods: {
    changeValue () {
      this.$emit('changeFilter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/registrationRequests/list/filter.vue